<div
  class="fixed inset-0 z-50 flex justify-center items-center text-mobileMd tablet:text-tabletMd desktop:text-desktopMd"
  (click)="$event.stopPropagation()"
>
  <div class="m-4 p-8 desktop:p-12 tablet:p-10 bg-white rounded-xl w-[546px]">
    <ng-content></ng-content>
  </div>
</div>
